<template lang="pug">
  div.checkbox-list
    div.checkbox-list__label(v-if='required')
      | {{label + ' '}}
      span.input-field__label-tooltip * <span>Обязательное поле</span>
    div.checkbox-list__label(v-else) {{label}}
    ul.checkbox-list__list
      template(v-for="el in options")
        li.checkbox-list__list-item
          input-check(
            v-bind="[...el]"
            :value="el.value"
            :dependent="dependent"
            :pollId="pollId"
            :event="'onChange'"
            :stateChecked="checked.includes(el.id)")
    div.checkbox-list__error(v-if="hasError")
      | {{errorMessage}}
</template>

<script>
  // vendor
  import _remove from 'lodash/remove';

  // mixins
  import fieldProps from '@/mixins/fieldProps';

  // components
  import CheckboxRadio from '@/components/UI/CheckboxRadio/CheckboxRadio.vue';

  export default {
    name: 'CheckboxGroup',
    mixins: [fieldProps],
    components: {
      'input-check': CheckboxRadio
    },
    props: {
      options: {
        type: Array,
        required: true
      },
      selectedOpts: {
        type: Array,
        default: () => ([])
      }
    },
    computed: {
      checked () {
        return this.$props.selectedOpts.map((opt) => {
          return opt.id
        })
      }
    },
    methods: {
      validator () {
        this.hasError = !this.inputVal.length && !this.$props.selectedOpts.length && this.$props.required === true;
      },
      changeHandler (data) {
        if (data.checked) {
          this.inputVal.push(data);
        } else {
          _remove(this.inputVal, (o) => {
            return data.id === o.id;
          });
        }

        const answer = {
          pollId: this.$props.pollId,
          question: this.$props.question,
          options: this.inputVal
        };

        // TODO: надо бы как то выделить получение опросов чтобы убрать условие в этом компоненте и в answers/actions
        if (this.$props.pollId === 21) { // id опроса выбора тем опросов
          this.$store.dispatch('answers/addRemovePoll', data);
        }

        this.validator();
        if (this.hasError) {
          return false;
        }

        this.$store.dispatch('answers/addRemoveAnswer', answer);
      }
    },
    mounted () {
      this.$on('onChange', this.changeHandler)
    },
    data () {
      return {
        inputVal: this.$props.selectedOpts,
        hasError: false,
        errorMessage: this.$props.input_type ? this.$props.input_type.error : ''
      }
    }
  }
</script>

<style lang="scss" src="./assets/checkbox-list.scss"></style>
